module.exports = __webpack_public_path__ + "3b6c152f849b91bf8c58d9dc949a464a.jpg";